// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./background-colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

body {
  /* font-family: Arial, Helvetica, sans-serif; */
  font-family: 'Nunito Sans', sans-serif;
}

.divider:after,
.divider:before {
content: "";
flex: 1 1;
height: 1px;
background: #eee;
}
.h-custom {
height: calc(100% - 57px);
}

.gradient-custom-2 {
  /* fallback for old browsers */
  background: #fccb90;
  color: #FFFFFF;
  /* Chrome 10-25, Safari 5.1-6 */ /* Milk white color */
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background: linear-gradient(to right, #ffffff, #ffffff); /* Milk white color */
}
    
.font-weight-light {
  font-family: sans-serif;
  color: #CCCD01;
}

@media (max-width: 450px) {
.h-custom {
height: 100%;
}
}

/* Start sidebar and sidbarmenu */  
* {
margin: 0;
padding: 0;
box-sizing: border-box;
}

.main-container {
display: flex;
}

main {
padding: 10px;
}

.title {
font-size: 3rem;
display: grid;
place-items: center;
}

/* Sidebar */
.sidebar {
/* background: linear-gradient(to right, #ffffff, #ffffff); */
 /* Milk white color */
background-color:var(--sidebbar-Bg-color);
color: gray;
/* height: 92.1vh; */
/* Adjust the side bar bottom spacing */
height: 91%;/* Adjust the side bar bottom spacing */
overflow-y: auto;
position: absolute; /* or position: fixed; */
top: 40.8px; /* Adjust the top spacing */
border-right: 1px solid #ddd; /* Adds a solid line to the right of the sidebar */
}


.top_section {
display: flex;
align-items: center;
justify-content: space-between;
padding: 15px 10px;
}
.logo-menu {
font-size: 18px;
line-height: 0;
margin-top: 9px ; /* Adjust menu name and push menu in one line */
margin-left: 30px;
color: #4d4948;
}

.bars {
width: 30px;
color: var(--BlackIcon-color);
}
.hide {
display: none;
}


.search {
display: flex;
align-items: center;
margin: 10px 0;
height: 30px;
padding: 10px;
}
.search input {
border: none;
margin-left: 10px;
border-radius: 5px;
background: rgb(238, 238, 238);
color: gray;
}


.routes {
margin-top: 15px; /* sidebar names taken top */
display: flex;
flex-direction: column;
gap: 2px;
}

.link {
  display: flex;
  color:var(--BlackIcon-color); /* Default color for icons */
  text-decoration: none; /* Remove underline */
  align-items: center; /* Fix alignment to center */
  gap: 10px;
  padding: 5px 10px;
  border-right: 4px solid transparent;
  transition: 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045);
}

.link:hover {
  /* border-right: 4px solid gray; */
  background: var(--link-active-color); /* Hover background color */
  color: var(--link-text-color); /* Change text color on hover */
  /* transition: 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045); */
}

.link.active {
  background: var(--link-active-color) ;/* Active background color */
  color: var(--whitefont-color); /* Active icon and text color */
  font-weight: 600; /* Make the icons and text bold */
}

.link_text {
  white-space: nowrap;
  font-size: var(--sideBar-Text-Font-Size);
  color: var(--sideBar-Text-color); /* Default sidebar text color */
  transition: transform 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045); /* Smooth zoom effect */
  /* padding-left: 20px; */
}


.link:hover .link_text {
  transform: scale(1.1); /* Zoom in on hover */
  /* padding-left: 20px; */
  color: var(--whitefont-color);
}

.submenu .nested-submenu .link_text {
  padding-left: 30px;
}

.link.active .link_text {
  color: #FFFFFF; /* Active sidebar text color */
  font-weight: 400; /* Bold text when active */
}

/* here side bar color given as gray */
.menu, .menu_container .menu {
display: flex;
color:var(--sidebar-icon-color); /* color changed for icons */
font-size: var(--sidebar-icon-Size);
padding: 3px 10px;
border-right: 4px solid transparent;
transition: 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045);
justify-content: space-between;
}

.menu_item {
display: flex;
gap: 10px;
width: 100%;
}

.menu_container {
display: flex;
flex-direction: column;
}

.menu_container .link {
 padding-left: 20px;
/*border-bottom: gray 0.5px solid; */
width: 100%;
}

/* First sublevel (direct submenu) */
.menu_container .submenu {
  padding-left: 0px;
}

/* Second sublevel (nested submenu) */
.menu_container .submenu .nested-submenu {
  padding-left: 0px;
}

img.logo {
  max-width: 100px;
  top: 6px;
  left: 79px;
  width: 100%;
  height: auto;
  object-fit: scale-down; /* Ensure the entire image is visible, scaling as needed */
}

/* ============================================================================== */
.App {
text-align: center;
}


.App-logo {
height: 40vmin;
pointer-events: none;
}


@media (prefers-reduced-motion: no-preference) {
.App-logo {
animation: App-logo-spin infinite 20s linear;
}
}


.App-header {
background-color: #282c34;
min-height: 100vh;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
font-size: calc(10px + 2vmin);
color: white;
}


.App-link {
color: #61dafb;
}


@keyframes App-logo-spin {
from {
transform: rotate(0deg);
}
to {
transform: rotate(360deg);
}
}
/* ============================================================================== */
.App {
text-align: center;
}


.App-logo {
height: 40vmin;
pointer-events: none;
}


@media (prefers-reduced-motion: no-preference) {
.App-logo {
animation: App-logo-spin infinite 20s linear;
}
}


.App-header {
background-color: #2b2834;
/* background-color: #2b2834; */
min-height: 100vh;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
font-size: calc(10px + 2vmin);
color: white;
}


.App-link {
color: orange;
}


@keyframes App-logo-spin {
from {
transform: rotate(0deg);
}
to {
transform: rotate(360deg);
}
}
/* ended sidebar and sidbarmenu */


.custom-alert-success {
  background-color: #d4edda; /* Custom background color for success */
  color: #155724; /* Custom text color for success */
  border-color: #c3e6cb; /* Custom border color for success */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.custom-alert-success .close {
  margin-left: auto;
  color: #155724; /* Custom close button color */
}

.btn-defined-primary {
  background-color: #E67016;
  color: #FFFFFF;
}

.breadcrumb.nav-breadcrumb a{
  text-decoration: none;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":";;AAIA;EACE,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;;AAEA,WAAW;AACX,SAAO;AACP,WAAW;AACX,gBAAgB;AAChB;AACA;AACA,yBAAyB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,+BAA+B,EACkC,qBAAqB;EACtF,qEAAqE;EACrE,uDAAuD,EAAE,qBAAqB;AAChF;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;AACA;AACA,YAAY;AACZ;AACA;;AAEA,iCAAiC;AACjC;AACA,SAAS;AACT,UAAU;AACV,sBAAsB;AACtB;;AAEA;AACA,aAAa;AACb;;AAEA;AACA,aAAa;AACb;;AAEA;AACA,eAAe;AACf,aAAa;AACb,mBAAmB;AACnB;;AAEA,YAAY;AACZ;AACA,6DAA6D;CAC5D,qBAAqB;AACtB,yCAAyC;AACzC,WAAW;AACX,oBAAoB;AACpB,uCAAuC;AACvC,WAAW,CAAC,uCAAuC;AACnD,gBAAgB;AAChB,kBAAkB,EAAE,wBAAwB;AAC5C,WAAW,EAAE,2BAA2B;AACxC,4BAA4B,EAAE,kDAAkD;AAChF;;;AAGA;AACA,aAAa;AACb,mBAAmB;AACnB,8BAA8B;AAC9B,kBAAkB;AAClB;AACA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB,EAAE,+CAA+C;AACjE,iBAAiB;AACjB,cAAc;AACd;;AAEA;AACA,WAAW;AACX,6BAA6B;AAC7B;AACA;AACA,aAAa;AACb;;;AAGA;AACA,aAAa;AACb,mBAAmB;AACnB,cAAc;AACd,YAAY;AACZ,aAAa;AACb;AACA;AACA,YAAY;AACZ,iBAAiB;AACjB,kBAAkB;AAClB,8BAA8B;AAC9B,WAAW;AACX;;;AAGA;AACA,gBAAgB,EAAE,4BAA4B;AAC9C,aAAa;AACb,sBAAsB;AACtB,QAAQ;AACR;;AAEA;EACE,aAAa;EACb,4BAA4B,EAAE,4BAA4B;EAC1D,qBAAqB,EAAE,qBAAqB;EAC5C,mBAAmB,EAAE,4BAA4B;EACjD,SAAS;EACT,iBAAiB;EACjB,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA;EACE,kCAAkC;EAClC,oCAAoC,EAAE,2BAA2B;EACjE,6BAA6B,EAAE,+BAA+B;EAC9D,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC,CAAC,4BAA4B;EAClE,6BAA6B,EAAE,+BAA+B;EAC9D,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,gCAAgC,EAAE,+BAA+B;EACjE,iEAAiE,EAAE,uBAAuB;EAC1F,wBAAwB;AAC1B;;;AAGA;EACE,qBAAqB,EAAE,qBAAqB;EAC5C,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,8BAA8B;EAC9C,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA,sCAAsC;AACtC;AACA,aAAa;AACb,+BAA+B,EAAE,4BAA4B;AAC7D,mCAAmC;AACnC,iBAAiB;AACjB,mCAAmC;AACnC,uDAAuD;AACvD,8BAA8B;AAC9B;;AAEA;AACA,aAAa;AACb,SAAS;AACT,WAAW;AACX;;AAEA;AACA,aAAa;AACb,sBAAsB;AACtB;;AAEA;CACC,kBAAkB;AACnB,oCAAoC;AACpC,WAAW;AACX;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE,0DAA0D;AACpF;;AAEA,mFAAmF;AACnF;AACA,kBAAkB;AAClB;;;AAGA;AACA,cAAc;AACd,oBAAoB;AACpB;;;AAGA;AACA;AACA,4CAA4C;AAC5C;AACA;;;AAGA;AACA,yBAAyB;AACzB,iBAAiB;AACjB,aAAa;AACb,sBAAsB;AACtB,mBAAmB;AACnB,uBAAuB;AACvB,6BAA6B;AAC7B,YAAY;AACZ;;;AAGA;AACA,cAAc;AACd;;;AAGA;AACA;AACA,uBAAuB;AACvB;AACA;AACA,yBAAyB;AACzB;AACA;AACA,mFAAmF;AACnF;AACA,kBAAkB;AAClB;;;AAGA;AACA,cAAc;AACd,oBAAoB;AACpB;;;AAGA;AACA;AACA,4CAA4C;AAC5C;AACA;;;AAGA;AACA,yBAAyB;AACzB,+BAA+B;AAC/B,iBAAiB;AACjB,aAAa;AACb,sBAAsB;AACtB,mBAAmB;AACnB,uBAAuB;AACvB,6BAA6B;AAC7B,YAAY;AACZ;;;AAGA;AACA,aAAa;AACb;;;AAGA;AACA;AACA,uBAAuB;AACvB;AACA;AACA,yBAAyB;AACzB;AACA;AACA,iCAAiC;;;AAGjC;EACE,yBAAyB,EAAE,wCAAwC;EACnE,cAAc,EAAE,kCAAkC;EAClD,qBAAqB,EAAE,oCAAoC;EAC3D,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":["\r\n\r\n@import './background-colors.css';\r\n\r\nbody {\r\n  /* font-family: Arial, Helvetica, sans-serif; */\r\n  font-family: 'Nunito Sans', sans-serif;\r\n}\r\n\r\n.divider:after,\r\n.divider:before {\r\ncontent: \"\";\r\nflex: 1;\r\nheight: 1px;\r\nbackground: #eee;\r\n}\r\n.h-custom {\r\nheight: calc(100% - 57px);\r\n}\r\n\r\n.gradient-custom-2 {\r\n  /* fallback for old browsers */\r\n  background: #fccb90;\r\n  color: #FFFFFF;\r\n  /* Chrome 10-25, Safari 5.1-6 */\r\n  background: -webkit-linear-gradient(to right, #ffffff, #ffffff); /* Milk white color */\r\n  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */\r\n  background: linear-gradient(to right, #ffffff, #ffffff); /* Milk white color */\r\n}\r\n    \r\n.font-weight-light {\r\n  font-family: sans-serif;\r\n  color: #CCCD01;\r\n}\r\n\r\n@media (max-width: 450px) {\r\n.h-custom {\r\nheight: 100%;\r\n}\r\n}\r\n\r\n/* Start sidebar and sidbarmenu */  \r\n* {\r\nmargin: 0;\r\npadding: 0;\r\nbox-sizing: border-box;\r\n}\r\n\r\n.main-container {\r\ndisplay: flex;\r\n}\r\n\r\nmain {\r\npadding: 10px;\r\n}\r\n\r\n.title {\r\nfont-size: 3rem;\r\ndisplay: grid;\r\nplace-items: center;\r\n}\r\n\r\n/* Sidebar */\r\n.sidebar {\r\n/* background: linear-gradient(to right, #ffffff, #ffffff); */\r\n /* Milk white color */\r\nbackground-color:var(--sidebbar-Bg-color);\r\ncolor: gray;\r\n/* height: 92.1vh; */\r\n/* Adjust the side bar bottom spacing */\r\nheight: 91%;/* Adjust the side bar bottom spacing */\r\noverflow-y: auto;\r\nposition: absolute; /* or position: fixed; */\r\ntop: 40.8px; /* Adjust the top spacing */\r\nborder-right: 1px solid #ddd; /* Adds a solid line to the right of the sidebar */\r\n}\r\n\r\n\r\n.top_section {\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: space-between;\r\npadding: 15px 10px;\r\n}\r\n.logo-menu {\r\nfont-size: 18px;\r\nline-height: 0;\r\nmargin-top: 9px ; /* Adjust menu name and push menu in one line */\r\nmargin-left: 30px;\r\ncolor: #4d4948;\r\n}\r\n\r\n.bars {\r\nwidth: 30px;\r\ncolor: var(--BlackIcon-color);\r\n}\r\n.hide {\r\ndisplay: none;\r\n}\r\n\r\n\r\n.search {\r\ndisplay: flex;\r\nalign-items: center;\r\nmargin: 10px 0;\r\nheight: 30px;\r\npadding: 10px;\r\n}\r\n.search input {\r\nborder: none;\r\nmargin-left: 10px;\r\nborder-radius: 5px;\r\nbackground: rgb(238, 238, 238);\r\ncolor: gray;\r\n}\r\n\r\n\r\n.routes {\r\nmargin-top: 15px; /* sidebar names taken top */\r\ndisplay: flex;\r\nflex-direction: column;\r\ngap: 2px;\r\n}\r\n\r\n.link {\r\n  display: flex;\r\n  color:var(--BlackIcon-color); /* Default color for icons */\r\n  text-decoration: none; /* Remove underline */\r\n  align-items: center; /* Fix alignment to center */\r\n  gap: 10px;\r\n  padding: 5px 10px;\r\n  border-right: 4px solid transparent;\r\n  transition: 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045);\r\n}\r\n\r\n.link:hover {\r\n  /* border-right: 4px solid gray; */\r\n  background: var(--link-active-color); /* Hover background color */\r\n  color: var(--link-text-color); /* Change text color on hover */\r\n  /* transition: 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045); */\r\n}\r\n\r\n.link.active {\r\n  background: var(--link-active-color) ;/* Active background color */\r\n  color: var(--whitefont-color); /* Active icon and text color */\r\n  font-weight: 600; /* Make the icons and text bold */\r\n}\r\n\r\n.link_text {\r\n  white-space: nowrap;\r\n  font-size: var(--sideBar-Text-Font-Size);\r\n  color: var(--sideBar-Text-color); /* Default sidebar text color */\r\n  transition: transform 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045); /* Smooth zoom effect */\r\n  /* padding-left: 20px; */\r\n}\r\n\r\n\r\n.link:hover .link_text {\r\n  transform: scale(1.1); /* Zoom in on hover */\r\n  /* padding-left: 20px; */\r\n  color: var(--whitefont-color);\r\n}\r\n\r\n.submenu .nested-submenu .link_text {\r\n  padding-left: 30px;\r\n}\r\n\r\n.link.active .link_text {\r\n  color: #FFFFFF; /* Active sidebar text color */\r\n  font-weight: 400; /* Bold text when active */\r\n}\r\n\r\n/* here side bar color given as gray */\r\n.menu, .menu_container .menu {\r\ndisplay: flex;\r\ncolor:var(--sidebar-icon-color); /* color changed for icons */\r\nfont-size: var(--sidebar-icon-Size);\r\npadding: 3px 10px;\r\nborder-right: 4px solid transparent;\r\ntransition: 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045);\r\njustify-content: space-between;\r\n}\r\n\r\n.menu_item {\r\ndisplay: flex;\r\ngap: 10px;\r\nwidth: 100%;\r\n}\r\n\r\n.menu_container {\r\ndisplay: flex;\r\nflex-direction: column;\r\n}\r\n\r\n.menu_container .link {\r\n padding-left: 20px;\r\n/*border-bottom: gray 0.5px solid; */\r\nwidth: 100%;\r\n}\r\n\r\n/* First sublevel (direct submenu) */\r\n.menu_container .submenu {\r\n  padding-left: 0px;\r\n}\r\n\r\n/* Second sublevel (nested submenu) */\r\n.menu_container .submenu .nested-submenu {\r\n  padding-left: 0px;\r\n}\r\n\r\nimg.logo {\r\n  max-width: 100px;\r\n  top: 6px;\r\n  left: 79px;\r\n  width: 100%;\r\n  height: auto;\r\n  object-fit: scale-down; /* Ensure the entire image is visible, scaling as needed */\r\n}\r\n\r\n/* ============================================================================== */\r\n.App {\r\ntext-align: center;\r\n}\r\n\r\n\r\n.App-logo {\r\nheight: 40vmin;\r\npointer-events: none;\r\n}\r\n\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n.App-logo {\r\nanimation: App-logo-spin infinite 20s linear;\r\n}\r\n}\r\n\r\n\r\n.App-header {\r\nbackground-color: #282c34;\r\nmin-height: 100vh;\r\ndisplay: flex;\r\nflex-direction: column;\r\nalign-items: center;\r\njustify-content: center;\r\nfont-size: calc(10px + 2vmin);\r\ncolor: white;\r\n}\r\n\r\n\r\n.App-link {\r\ncolor: #61dafb;\r\n}\r\n\r\n\r\n@keyframes App-logo-spin {\r\nfrom {\r\ntransform: rotate(0deg);\r\n}\r\nto {\r\ntransform: rotate(360deg);\r\n}\r\n}\r\n/* ============================================================================== */\r\n.App {\r\ntext-align: center;\r\n}\r\n\r\n\r\n.App-logo {\r\nheight: 40vmin;\r\npointer-events: none;\r\n}\r\n\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n.App-logo {\r\nanimation: App-logo-spin infinite 20s linear;\r\n}\r\n}\r\n\r\n\r\n.App-header {\r\nbackground-color: #2b2834;\r\n/* background-color: #2b2834; */\r\nmin-height: 100vh;\r\ndisplay: flex;\r\nflex-direction: column;\r\nalign-items: center;\r\njustify-content: center;\r\nfont-size: calc(10px + 2vmin);\r\ncolor: white;\r\n}\r\n\r\n\r\n.App-link {\r\ncolor: orange;\r\n}\r\n\r\n\r\n@keyframes App-logo-spin {\r\nfrom {\r\ntransform: rotate(0deg);\r\n}\r\nto {\r\ntransform: rotate(360deg);\r\n}\r\n}\r\n/* ended sidebar and sidbarmenu */\r\n\r\n\r\n.custom-alert-success {\r\n  background-color: #d4edda; /* Custom background color for success */\r\n  color: #155724; /* Custom text color for success */\r\n  border-color: #c3e6cb; /* Custom border color for success */\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.custom-alert-success .close {\r\n  margin-left: auto;\r\n  color: #155724; /* Custom close button color */\r\n}\r\n\r\n.btn-defined-primary {\r\n  background-color: #E67016;\r\n  color: #FFFFFF;\r\n}\r\n\r\n.breadcrumb.nav-breadcrumb a{\r\n  text-decoration: none;\r\n  font-size: 12px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
